import { render, staticRenderFns } from "./AnotherExpenses.vue?vue&type=template&id=0097765c&"
import script from "./AnotherExpenses.vue?vue&type=script&lang=js&"
export * from "./AnotherExpenses.vue?vue&type=script&lang=js&"
import style0 from "./AnotherExpenses.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports